// WhatsApp business number for order-via-WhatsApp (country code + number, digits only, no + or spaces)
export const WHATSAPP_NUMBER = "918852832320";

export function waLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
